import {UpmPlant, getUpmPlantById} from '@hconnect/apiclient'
import {QueryFunction, useQuery} from '@tanstack/react-query'

import {api} from '../App.store'

type UpmPlantParam = {
  upmId: string
}

const fetcher: QueryFunction<UpmPlant, [string, UpmPlantParam]> = ({
  queryKey
}: {
  queryKey: [string, UpmPlantParam]
}): Promise<UpmPlant> => {
  const [, {upmId}] = queryKey

  return getUpmPlantById(api)(upmId)
}

export const useUpmPlant = ({upmId}: UpmPlantParam) => {
  return useQuery(['upmPlants', {upmId}], fetcher, {retry: false})
}
